import React, { useRef } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import Button from '../../../components/ui/Button';
import useProgressHeartbeat from './useProgressHeartbeat';

const Wrap = styled.div`
  background: #fff;
  border: 1px solid #E0E4E8;
  border-radius: 6px;
  padding: 12px;
  text-align: center;

  img {
    max-width: 100%;
    max-height: 70vh;
    border-radius: 4px;
  }
`;

const Footer = styled.div`
  margin-top: 10px;
  display: flex;
  justify-content: flex-end;
`;

export default function ImageViewer({ contentItem, assignmentId, onCompleted, onProgress }) {
  const { t } = useTranslation();
  const doneRef = useRef(contentItem.isCompleted ?? false);

  const getState = () => ({
    contentItemId: contentItem.id,
    clientCompleted: doneRef.current,
  });
  const flush = useProgressHeartbeat(assignmentId, getState, (res) => {
    if (res?.isCompleted) onCompleted?.();
    onProgress?.(res);
  });

  const markDone = async () => {
    doneRef.current = true;
    await flush({ clientCompleted: true });
    onCompleted?.();
  };

  return (
    <Wrap>
      <img src={contentItem.url} alt={contentItem.originalFileName || ''} />
      {assignmentId && !contentItem.isCompleted && (
        <Footer>
          <Button type="button" $variant="primary" onClick={markDone}>
            {t('training.markAsViewed')}
          </Button>
        </Footer>
      )}
    </Wrap>
  );
}
